import {Tooltip, Typography} from "antd";
import {listNguonVTYT, listTTPhieuKho, listTTPhieuVTYT} from "data/list";
import moment from "moment";
import React from "react";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {ColumnProps} from "types/models";
import {ColumnsEdit} from "types/models/column-table-edit";

const {INPUT,SELECT, CURRENCY, DATE, NUMBER, COMBO_BOX, CODE, AUTO_COMPLETE,} =
  FIELD_TYPE;

const columns: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: 80,
    show: true,
    align: "center",
  },
  {
    type: INPUT,
    dataIndex: "phongBan",
    key: "phongBan",
    title: "Phòng",
    disabled:true,
    show: true,
    width: 200,
  },
  {
    type: INPUT,
    dataIndex: "maNhanVien",
    key: "maNhanVien",
    title: "Mã Nhân viên",
    show: true,
    width: 200,
    disabled:true,

  },
  {
    type: COMBO_BOX,
    dataIndex: "idNhanVien",
    key: "0",
    title: "Họ tên",
    show: true,
    width: 200,
  },
  {
    type: INPUT,
    dataIndex: "ketQuaDaoTao",
    key: "0",
    title: "Kết quả đào tạo",
    show: true,
    width: 200,
  },
  {
    type: INPUT,
    dataIndex: "chungChi",
    key: "0",
    title: "Upload chứng chỉ",
    show: true,
    width: 200,
    disabled:true
  },
  {
    type: NUMBER,
    dataIndex: "files",
    key: "0",
    title: "",
    show: true,
    width: 200,
    disabled:true
  },
  {
    title: "",
    dataIndex: "",
    key: "action",
    align: "center",
    width: 60,
    fixed: "right" as any,
    show: true,
  },
];
export {columns};
